import Image from "next/image";
import styles from "./Section1.module.scss";

export const Section1 = function () {
  return (
    <section id="programme_detail" className={`${styles.section1Container} cc--component-container`}>
      <div className={styles.itemContainer}>
        <div className={styles.itemRow}>
          <div className={styles.item}>
            <Image
              src="https://www.getsmarter.com/presentations/wp-content/uploads/2019/03/a1e8a4e1-calendar_02w02w02w02w000000001.png"
              alt="Duration"
              height={70}
              width={70}
            />
            <p>
              6 weeks, excluding
              <br />
              orientation
            </p>
          </div>
          <div className={styles.item}>
            <Image
              src="https://www.getsmarter.com/presentations/wp-content/uploads/2019/03/ea3f68f7-csail-time_02w02w02s02k000007001.png"
              alt="Effort"
              height={70}
              width={76}
            />
            <p>
              6-8 hours per week,
              <br />
              self-paced learning online
            </p>
          </div>
          <div className={styles.item}>
            <Image
              src="https://www.getsmarter.com/presentations/wp-content/uploads/2019/03/68ed3643-mitsloan-icons-mod_028028028028000000001.png"
              alt="Learning Format"
              height={70}
              width={70}
            />
            <p>
              Weekly modules,
              <br />
              flexible learning
            </p>
          </div>
          <div className={styles.item}>
            <Image
              src="https://www.getsmarter.com/presentations/wp-content/uploads/2019/11/e72b6e3d-certidicate-sl_000000000000000000001.png"
              alt="Other Detail"
              height={70}
              width={70}
            />
            <p>Earn an MIT Sloan certificate</p>
          </div>
        </div>
      </div>
    </section>
  );
};
